import { useEffect, useState } from 'react';

import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText,
    DialogTitle, TextField
} from '@mui/material';

const ReplyDialog = ({ busy, onClose, onSave, open, review }) => {
    const [text, setText] = useState('');

    useEffect(() => {
        if (open)
            setText(review?.admin_reply?.text || '');
    }, [open, review]);

    const length = text.trim().length;
    const invalid = length < 6 || length > 1000 ||
        /<\/?[a-z][^>]*>/i.test(text);

    return (
        <Dialog fullWidth maxWidth="sm" onClose={busy ? undefined : onClose} open={open}>
            <DialogTitle>
                {review?.admin_reply?.text ? 'Editar respuesta' : 'Responder reseña'}
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                    La respuesta será visible en la tienda como “Equipo Nefrópolis”.
                </DialogContentText>
                <TextField
                    autoFocus
                    error={length > 0 && invalid}
                    fullWidth
                    helperText={`${length}/1000 caracteres. No se admite HTML.`}
                    inputProps={{ maxLength: 1000 }}
                    label="Respuesta pública"
                    minRows={5}
                    multiline
                    onChange={({ target }) => setText(target.value)}
                    value={text}
                />
            </DialogContent>
            <DialogActions>
                <Button disabled={busy} onClick={onClose}>Cancelar</Button>
                <Button
                    disabled={busy || invalid}
                    onClick={() => onSave(text.trim())}
                    variant="contained"
                >
                    Publicar respuesta
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReplyDialog;
